import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

export const endpoints = {
  current: () => api.get("/weather/current").then((r) => r.data),
  history: (range) => api.get(`/weather/history`, { params: { range } }).then((r) => r.data),
  records: () => api.get("/weather/records").then((r) => r.data),
  station: () => api.get("/station").then((r) => r.data),
  searchDate: (date) => api.get(`/weather/search`, { params: { date } }).then((r) => r.data),
  contact: (payload) => api.post(`/contact`, payload).then((r) => r.data),
};
